/**
 * Whether a submitted form is automatically exported to the destination system on completion, or
 * left for a separate downstream export step. Part of the primary form-submission contract.
 */
export var FlowExportMode;
(function (FlowExportMode) {
    FlowExportMode["RunAutoExport"] = "RUN_AUTO_EXPORT";
    FlowExportMode["NoAutoExport"] = "NO_AUTO_EXPORT";
})(FlowExportMode || (FlowExportMode = {}));
//# sourceMappingURL=exportMode.js.map